module.exports = __webpack_public_path__ + "img/damage_detail_blaupause.95393385.gif";